import { debounce, schedule } from '@ember/runloop';

import { modifier } from 'ember-modifier';
import $ from 'jquery';

export const containerDomClass = 'visible-check__container';
export const itemDomClass = 'visible-check__item';
export const itemEventName = 'custom.visible-check-on-item';
export const containerEventName = 'custom.contentchange';

// Used together with modifiers/visible-check-item
// On body's (and node's, if isElementScrollable is true) scroll event sends custom event to all items
// also listens for containerEventName ^ event to trigger this event manually

const visibleCheckContainer = (node: HTMLElement, [isElementScrollable = false]) => {
	const visibleCheckFn = (e: Event) => {
		// don't do anything if page is not visible
		if (document.visibilityState === 'hidden') {
			return;
		}
		const itemNodes = node.querySelectorAll(`.${itemDomClass}`);
		const scrollContainerNode =
			isElementScrollable && e?.target && e.target !== document ? e.target : window;
		const event = new CustomEvent(itemEventName, {
			detail: { scrollContainerNode },
		});
		Array.from(itemNodes).forEach((node) => node.dispatchEvent(event));
	};

	const debouncedVisibleCheckFn = (e: Event) => {
		debounce(null, visibleCheckFn, e, 100);
	};

	window.addEventListener('scroll', debouncedVisibleCheckFn);
	window.addEventListener('orientationchange', debouncedVisibleCheckFn);
	// window.addEventListener('resize', debouncedVisibleCheckFn);
	document.addEventListener('visibilitychange', debouncedVisibleCheckFn);

	if (isElementScrollable) {
		node.addEventListener('scroll', debouncedVisibleCheckFn);
	}

	node.addEventListener(containerEventName, visibleCheckFn);

	node.classList.add(containerDomClass);

	// also update colspan on dummy-cells on flexible tables
	let debouncedColspanUpdateFn: (() => void) | null = null;
	if (node.classList.contains('flexible-table')) {
		const colspanUpdateFn = () => {
			const dummyCellNodes = node.querySelectorAll(`.${itemDomClass} .dummy-cell`);

			if (!dummyCellNodes.length) {
				return;
			}

			// set visible column count
			let visibleColumns = 0;
			Array.from(node.getElementsByTagName('th')).forEach((n) => {
				if ($(n).is(':visible')) {
					const colspan = n.getAttribute('colspan') || 1;
					visibleColumns += +colspan;
				}
			});

			dummyCellNodes.forEach((n) => {
				n.setAttribute('colspan', String(visibleColumns));
			});
		};

		debouncedColspanUpdateFn = () => {
			debounce(colspanUpdateFn, 100);
		};

		window.addEventListener('resize', debouncedColspanUpdateFn);
		node.addEventListener(containerEventName, debouncedColspanUpdateFn);

		schedule('afterRender', debouncedColspanUpdateFn);
	}

	return () => {
		window.removeEventListener('scroll', debouncedVisibleCheckFn);
		window.removeEventListener('orientationchange', debouncedVisibleCheckFn);
		// window.removeEventListener('resize', debouncedVisibleCheckFn);
		document.removeEventListener('visibilitychange', debouncedVisibleCheckFn);
		node.removeEventListener('scroll', debouncedVisibleCheckFn);
		node.removeEventListener(containerEventName, visibleCheckFn);
		if (debouncedColspanUpdateFn) {
			window.removeEventListener('resize', debouncedColspanUpdateFn);
			node.removeEventListener(containerEventName, debouncedColspanUpdateFn);
		}
	};
};

const visibleCheckContainerModifier = modifier(visibleCheckContainer);

export default visibleCheckContainerModifier;
